import React from 'react';
import "./CTA.css"
import { Container } from 'react-bootstrap';

export default function CTA({buttonText,href,title}) {
  return (
    <Container>
    <div className='cta-container text-center '>
        <h2 className='text-center mb-4 title'>{title}</h2>
        <a className='d-inline-block mt-md-1 mt-0' href={href} target='_blank' rel='noreferrer'>{buttonText}</a>
    </div>
    </Container>
  )
}
